import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SlaaskChatService } from './shared/services/slaask-chat.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  constructor(private readonly slaaskChat: SlaaskChatService) {}

  ngOnInit(): void {
    this.slaaskChat.init();
  }
}
